import { render, staticRenderFns } from "./BotBubble.vue?vue&type=template&id=f4fd1628&scoped=true"
import script from "./BotBubble.vue?vue&type=script&lang=js"
export * from "./BotBubble.vue?vue&type=script&lang=js"
import style0 from "./BotBubble.vue?vue&type=style&index=0&id=f4fd1628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fd1628",
  null
  
)

export default component.exports